// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_oy-0";
export var animationContainer = "_oy-1";
export var itemPrice = "_oy-a";
export var itemizedContent = "_oy-9";
export var itemizedHeader = "_oy-7";
export var itemizedRow = "_oy-8";
export var itemizedSection = "_oy-6";
export var modalContent = "_oy-2";
export var orderName = "_oy-3";
export var refundOption = "_oy-4";
export var refundOptionsContainer = "_oy-5";
export var shippingLabel = "_oy-b";
export var totalRow = "_oy-c";